module.exports = __webpack_public_path__ + "media/images/childcare/main_image2-da07153aff553478e46302147ec8d7b8.jpg";